export default {
  FETCH_RECURRENT_ENTITY_ADMIN: 'FETCH_RECURRENT_ENTITY_ADMIN',
  FETCH_RECURRENT_ENTITY_ADMIN_SUCCESS: 'FETCH_RECURRENT_ENTITY_ADMIN_SUCCESS',
  OPEN_ADD_RECURRENT_ENTITY_MODAL: 'OPEN_ADD_RECURRENT_ENTITY_MODAL',
  OPEN_ADD_RECURRENT_ENTITY_MODAL_SUCCESS: 'OPEN_ADD_RECURRENT_ENTITY_MODAL_SUCCESS',
  OPEN_EDIT_RECURRENT_ENTITY_MODAL: 'OPEN_EDIT_RECURRENT_ENTITY_MODAL',
  OPEN_EDIT_RECURRENT_ENTITY_MODAL_SUCCESS: 'OPEN_EDIT_RECURRENT_ENTITY_MODAL_SUCCESS',
  CLOSE_EDIT_RECURRENT_ENTITY_MODAL: 'CLOSE_EDIT_RECURRENT_ENTITY_MODAL',
  SUBMIT_RECURRENT_ENTITY: 'SUBMIT_RECURRENT_ENTITY',
  DELETE_RECURRENT_ENTITY: 'DELETE_RECURRENT_ENTITY',
  FETCH_DOCUMENT_LIST_ADMIN: 'FETCH_DOCUMENT_LIST_ADMIN',
  FETCH_DOCUMENT_LIST_ADMIN_SUCCESS: 'FETCH_DOCUMENT_LIST_ADMIN_SUCCESS',
  FETCH_ENTITY_SUB_TYPES_LIST: 'FETCH_ENTITY_SUB_TYPES_LIST',
  FETCH_ENTITY_SUB_TYPES_LIST_SUCCESS: 'FETCH_ENTITY_SUB_TYPES_LIST_SUCCESS',
  UPLOAD_REC_ENTITY_MASS_DOCUMENT: 'UPLOAD_REC_ENTITY_MASS_DOCUMENT',
  SET_CHANGE_TAB_FROM_MASTER: 'SET_CHANGE_TAB_FROM_MASTER',
  SET_CHANGE_TAB_FROM_MASTER_SUCCESS: 'SET_CHANGE_TAB_FROM_MASTER_SUCCESS'
}
